<button class="btn btn-primary float-right" (click)="downloadUrl()" type="submit" value="submit search">Download</button>

<ngx-doc-viewer 
[url]="doc" 
  googleCheckContentLoaded="false"
  (loaded)="contentLoaded()"
  [viewer]="viewer" style="width:100%;height:920px;" ></ngx-doc-viewer>

  <ngx-spinner bdColor="rgba(51, 51, 51, 1.0)" size="default" type="ball-spin-clockwise">  
    <p style="color: white">Please Wait for Preview or Click Download button. </p>  
    <div class="downloadBtn">
    <button class="btn btn-primary" (click)="downloadUrl()" type="submit" value="submit search">Download</button>
  </div>
</ngx-spinner> 
